module.exports = __webpack_public_path__ + "static/media/double_room.c65f5f56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/DoubleRoom/images/double_room.jpg
// module id = 433
// module chunks = 0